import React, { useState } from 'react';
import { useIntl } from 'react-intl';
import { PlusOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import PropTypes from 'prop-types';
import { getactionMessages } from '../../../constants/messages';
import AddOrEditModal from './AddOrEditModal';

let ActionMessages = getactionMessages();

const messages = {
	...ActionMessages,
};

const AddButton = ({ updateTable, clients }) => {
	const intl = useIntl();
	const [showModal, setShowModal] = useState(false);

	return (
		<span>
			<Button className="editable-add-btn" type="primary" onClick={() => setShowModal(true)}>
				<PlusOutlined />
				{intl.formatMessage({ ...messages.add })}
			</Button>
			<AddOrEditModal
				title={intl.formatMessage({ ...messages.add })}
				showModal={showModal}
				onCancel={() => setShowModal(false)}
				updateTable={updateTable}
				clients={clients}
			/>
		</span>
	);
};

AddButton.propTypes = {
	updateTable: PropTypes.func,
	clients: PropTypes.array,
};

export default AddButton;
